import { AfterViewChecked, Component, Inject } from '@angular/core';
import { MatSnackBarConfig, MatSnackBarRef, MAT_SNACK_BAR_DATA, MAT_SNACK_BAR_DEFAULT_OPTIONS } from '@angular/material/snack-bar';
import * as feather from 'feather-icons';

@Component({
    selector: 'app-snackbar',
    templateUrl: './snackbar.component.html',
    styleUrls: ['./snackbar.component.css'],
    standalone: false
})
export class SnackbarComponent implements AfterViewChecked {
    constructor(
        public snackBarRef: MatSnackBarRef<SnackbarComponent>,
        @Inject(MAT_SNACK_BAR_DATA) public data: any, @Inject(MAT_SNACK_BAR_DEFAULT_OPTIONS) public options: MatSnackBarConfig
    ) { }

    ngAfterViewChecked(){
        feather.replace();
    }
}
